export default __webpack_public_path__ + "static/media/ellipse-569.0eebda75.svg";